import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Sql server driver requires parameter types to be specified fo input parameters used in the query.
 *
 * @see https://github.com/patriksimek/node-mssql#data-types
 */
export var MssqlParameter = /*#__PURE__*/_createClass(function MssqlParameter(value, type) {
  _classCallCheck(this, MssqlParameter);
  this.value = value;
  this.type = type;
  this["@instanceof"] = Symbol.for("MssqlParameter");
  // -------------------------------------------------------------------------
  // Public Properties
  // -------------------------------------------------------------------------
  this.params = [];
  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }
  this.params = params || [];
});